module.exports = __webpack_public_path__ + "static/media/home_awe.5f88001a.png";